import {
  defaultFailedSendCreditTasksListFilter,
  failedSendCreditTasksListColumnVisibilityOptions,
  defaultFailedSendCreditTasksListColumnVisibility,
} from '@utils/tables/failedSendCreditTasks/failedSendCreditTasksListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  limit: 25,
  page: 1,
  total: 0,
  selectedFilters: defaultFailedSendCreditTasksListFilter,
  columnVisibility: defaultFailedSendCreditTasksListColumnVisibility,
  columnVisibilityOptions: failedSendCreditTasksListColumnVisibilityOptions,
  failedSendCreditTasksTableFilters: {},
};

const failedSendCreditTasksTableSlice = createSlice({
  name: 'failedSendCreditTasksTable',
  initialState,
  reducers: {
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setLimit: (state, { payload }) => {
      state.limit = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setTotal: (state, { payload }) => {
      state.total = payload;
    },
    setFailedSendCreditTasksTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { failedSendCreditTasksTableFilters } = state;

      const convertedValue = typeof value !== 'object' || value === null ? value : value[0];
      const newProviderTransactionTableFilters = {
        ...failedSendCreditTasksTableFilters,
        [codeName]:
          convertedValue === 'true' ? true : convertedValue === 'false' ? false : convertedValue,
      };
      state.failedSendCreditTasksTableFilters = newProviderTransactionTableFilters;
    },
    setClearFailedSendCreditTasksTableFilters: (state) => {
      state.failedSendCreditTasksTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: failedSendCreditTasksTableReducer } = failedSendCreditTasksTableSlice;
export const {
  setColumnVisibility,
  setLimit,
  setPage,
  setTotal,
  setFailedSendCreditTasksTableFilters,
  setClearFailedSendCreditTasksTableFilters,
} = failedSendCreditTasksTableSlice.actions;
